const Layout = () => import('@/layout/index.vue')

export default {
    path: '/subagent',
    component: Layout,
    redirect: '/subagent/index',
    name: 'subagent',
    meta: {
        title: '下级代理',
        icon: 'commission'
    },
    children: [
        {
            path: 'index',
            name: 'subagentChild',
            component: () => import('@/views/subagent/index.vue'),
            meta: {
                title: '下级代理',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/subagent',
                auth: ['subagent']
            }
        }
    ]
}
